import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Label from 'reactstrap/lib/Label';
import Switch from 'react-switch';
import { useToggle } from 'site-modules/shared/hooks/use-toggle';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';

export function HideSimilaritiesSwitch({ hideSimilar, toggleHideSimilar, className }) {
  const [displayValue, toggleDisplayValue] = useToggle(hideSimilar);

  // to avoid INP issue
  useEffect(() => {
    if (displayValue !== hideSimilar) {
      setTimeout(() => {
        EventToolbox.fireTrackAction({
          event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
          event_data: {
            action_name: TrackingConstant.ACTION_VIEW_CONTENT,
            subaction_name: 'hide_similarities',
            action_category: TrackingConstant.USER_ACTION_CATEGORY,
            action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
            creative_id: 'trim-comparator',
            value: displayValue ? 'on' : 'off',
          },
        });
        toggleHideSimilar();
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayValue]);

  return (
    <Label for="hide-similarities" className={classnames('d-flex align-items-center', className)}>
      Hide similarities{' '}
      <Switch
        id="hide-similarities"
        className="hide-similarities-switch mx-0_5"
        onChange={toggleDisplayValue}
        checked={displayValue}
        offColor="#cbd4e1"
        onColor="#58b883"
        uncheckedIcon={false}
        checkedIcon={false}
        height={20}
        width={40}
        handleDiameter={14}
        activeBoxShadow={null}
      />
      <span>{displayValue ? 'On' : 'Off'}</span>
    </Label>
  );
}

HideSimilaritiesSwitch.propTypes = {
  hideSimilar: PropTypes.bool.isRequired,
  toggleHideSimilar: PropTypes.func.isRequired,
  className: PropTypes.string,
};

HideSimilaritiesSwitch.defaultProps = {
  className: 'mb-0',
};
